import React from "react";
import { Route, Switch, useRouteMatch, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  RequestListComponent,
  SiderComponent,
  EditRequestComponent,
  RequestDetailsComponent,
} from "./components";
import Loader from "./Loader";

import "./styles/autoLombardLayout.scss";

const AutoLombardLayout = ({ setTitlePage }) => {
  const match = useRouteMatch();
  const { isLoadingConfiguration } = useSelector(({ user }) => user);

  return (
    <div className="content-request">
       <SiderComponent />
      <div className="content-request-wrapper">
        {isLoadingConfiguration ? (
          <div className="content-inner">
            <Loader pageRange={1} />
          </div>
        ) : (
          <div className="autolombard-wrapper">
            <div className="content-datatable h-100">
              <Switch>
                <Route
                  path={`${match.url}/requests`}
                  exact
                  render={() => (
                    <RequestListComponent setTitlePage={setTitlePage} />
                  )}
                />
                <Route
                  path={`${match.url}/changes`}
                  exact
                  render={() => (
                    <EditRequestComponent setTitlePage={setTitlePage} />
                  )}
                />
                <Route
                  path={`/auto/requests/:id`}
                  exact
                  render={() => (
                    <RequestDetailsComponent setTitlePage={setTitlePage} />
                  )}
                />
                <Redirect
                  from={`${match.path}`}
                  to={`${match.path}/requests`}
                />
              </Switch>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AutoLombardLayout;
